// import React from 'react'

// const FilterProductSearch = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default FilterProductSearch


import React, { useState, useEffect, useContext, useRef } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Autocomplete,
  AppBar,
  Chip,Button
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { externalgetApi } from "../../services/externalApis";
import { SETTING_API_07,SETTING_API_02,SETTING_API_01 } from "../../api/ApiModel";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import SearchIcon from '@mui/icons-material/Search';
function FilterProductSearch({
  grnOptions = [],
  warehouseOptions = [],
  statusOptions = [],
  onFilterChange = () => {},
}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [filterType, setFilterType] = useState("productname");
const [searchValue, setSearchValue] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const {    LOCCODE,COMPCODE,STAFFMAPLOCODE
     } = SYS_USER.USER_PARAM || {};
       const [data, setData] = useState(null);
         const [data1, setData1] = useState(null);
           const [data2, setData2] = useState(null);
    useEffect(() => {
    const fetchData = async () => {
      try {
      const result = await externalgetApi(SETTING_API_07, "get", {
       COMPCODE,
         LOCCODE:STAFFMAPLOCODE,
    
          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
   
      console.log("result", result);
       
      } catch (err) {
        
      }
    };

    fetchData();
  }, []);

    useEffect(() => {
    const fetchData = async () => {
      try {
      const result = await externalgetApi(SETTING_API_02, "get", {
        COMPCODE,
          LOCCODE:STAFFMAPLOCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setData1(result);
    
      console.log("result", result);
      
      } catch (err) {
       
      }
    };

    fetchData();
  }, []);

    useEffect(() => {
    const fetchData = async () => {
      try {
      const result = await externalgetApi(SETTING_API_01, "get", {
        COMPCODE,
          LOCCODE:STAFFMAPLOCODE,
      

    
          STS: CON_STATUS_ACTIVE,
        });

        setData2(result);
      
      } catch (err) {
      
      }
    };

    fetchData();
  }, []);

  const [filters, setFilters] = useState({
    grnId: "",
    brandname: "",
    catname: "",
    productname: "",
  });

  const handleChange = (field, value) => {
    const updated = { ...filters, [field]: value };
    setFilters(updated);
    onFilterChange(updated); // Notify parent
  };
  const handleStatusChange = (e) => {
    const value = e.target.value;
    const updated = { ...filters, status: value };
    setFilters(updated);
    onFilterChange(updated);
  };

  return (
    <>
      <AppBar sx={styles.vg_search_appbar}>
    <Grid container spacing={2} sx={styles.appbar_grid_container} alignItems="center" justifyContent="flex-end">

  <Grid item size={{ xs: 12, sm: 8, md: 6, lg: 7, xl: 6 }}>
    <Autocomplete
      freeSolo
      fullWidth
      value={searchValue}
      onChange={(e, value) => setSearchValue(value)}
      options={
        filterType === "productname"
          ? data?.map((row) => row.productname) || []
          : filterType === "catname"
          ? data1?.map((row) => row.catname) || []
          : data2?.map((row) => row.brandname) || []
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={`Search by ${filterType === "productname" ? "Product Name" : filterType === "catname" ? "Category Name" : "Brand Name"}`}
          size="small"
          sx={styles.ipt_appbar_search}
        />
      )}
    />
  </Grid>
    <Grid item size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3 }}>
    <FormControl fullWidth size="small">
      <InputLabel id="filter-type-label">Filter By</InputLabel>
      <Select
        labelId="filter-type-label"
        id="filter-type"
        value={filterType}
        label="Filter By"
        onChange={(e) => {
          setFilterType(e.target.value);
          setSearchValue(""); // reset search value on filter type change
        }}
      >
        <MenuItem value="productname">Product Name</MenuItem>
        <MenuItem value="catname">Category Name</MenuItem>
        <MenuItem value="brandname">Brand Name</MenuItem>
      </Select>
    </FormControl>
  </Grid>
  <Grid item size={{ xs: 12, sm: 12, md: 3, lg: 2, xl: 3 }} sx={{ display: "flex", alignItems: "center", }}>
    <Button
      variant="contained"
  

      sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
      onClick={() => onFilterChange(filterType, searchValue)}
    >
      <SearchIcon />
    </Button>
  </Grid>
</Grid>
      </AppBar>
    </>
  );
}

export default FilterProductSearch;
